import React from 'react';
import "./contact.css";

export const ContactComponent = () => {
  return (
    <div className="contact-container">
      <h4>If you have any questions, concerns, or suggestions, please feel free to contact us at:</h4>
      <a href = "mailto: mail@halalvote.com"> mail@halalvote.com</a>
    </div>
  )
}

